module.exports = {
	"title": "CSS Appearance",
	"description": "The `appearance` property defines how elements (particularly form controls) appear by default. By setting the value to `none` the default appearance can be entirely redefined using other CSS properties.",
	"spec": "https://drafts.csswg.org/css-ui-4/#appearance-switching",
	"status": "wd",
	"links": [
		{
			"url": "http://css-tricks.com/almanac/properties/a/appearance/",
			"title": "CSS Tricks article"
		}
	],
	"bugs": [],
	"categories": [
		"CSS"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"5.5": "n"
		},
		"edge": {
			"12": "a #1 #2",
			"13": "a #1 #2",
			"14": "a #1 #2"
		},
		"firefox": {
			"2": "a x #1",
			"3": "a x #1",
			"4": "a x #1",
			"5": "a x #1",
			"6": "a x #1",
			"7": "a x #1",
			"8": "a x #1",
			"9": "a x #1",
			"10": "a x #1",
			"11": "a x #1",
			"12": "a x #1",
			"13": "a x #1",
			"14": "a x #1",
			"15": "a x #1",
			"16": "a x #1",
			"17": "a x #1",
			"18": "a x #1",
			"19": "a x #1",
			"20": "a x #1",
			"21": "a x #1",
			"22": "a x #1",
			"23": "a x #1",
			"24": "a x #1",
			"25": "a x #1",
			"26": "a x #1",
			"27": "a x #1",
			"28": "a x #1",
			"29": "a x #1",
			"30": "a x #1",
			"31": "a x #1",
			"32": "a x #1",
			"33": "a x #1",
			"34": "a x #1",
			"35": "a x #1",
			"36": "a x #1",
			"37": "a x #1",
			"38": "a x #1",
			"39": "a x #1",
			"40": "a x #1",
			"41": "a x #1",
			"42": "a x #1",
			"43": "a x #1",
			"44": "a x #1",
			"45": "a x #1",
			"46": "a x #1",
			"47": "a x #1",
			"48": "a x #1",
			"49": "a x #1",
			"50": "a x #1",
			"51": "a x #1",
			"52": "a x #1",
			"53": "a x #1",
			"3.5": "a x #1",
			"3.6": "a x #1"
		},
		"chrome": {
			"4": "a x #1",
			"5": "a x #1",
			"6": "a x #1",
			"7": "a x #1",
			"8": "a x #1",
			"9": "a x #1",
			"10": "a x #1",
			"11": "a x #1",
			"12": "a x #1",
			"13": "a x #1",
			"14": "a x #1",
			"15": "a x #1",
			"16": "a x #1",
			"17": "a x #1",
			"18": "a x #1",
			"19": "a x #1",
			"20": "a x #1",
			"21": "a x #1",
			"22": "a x #1",
			"23": "a x #1",
			"24": "a x #1",
			"25": "a x #1",
			"26": "a x #1",
			"27": "a x #1",
			"28": "a x #1",
			"29": "a x #1",
			"30": "a x #1",
			"31": "a x #1",
			"32": "a x #1",
			"33": "a x #1",
			"34": "a x #1",
			"35": "a x #1",
			"36": "a x #1",
			"37": "a x #1",
			"38": "a x #1",
			"39": "a x #1",
			"40": "a x #1",
			"41": "a x #1",
			"42": "a x #1",
			"43": "a x #1",
			"44": "a x #1",
			"45": "a x #1",
			"46": "a x #1",
			"47": "a x #1",
			"48": "a x #1",
			"49": "a x #1",
			"50": "a x #1",
			"51": "a x #1",
			"52": "a x #1",
			"53": "a x #1",
			"54": "a x #1",
			"55": "a x #1",
			"56": "a x #1",
			"57": "a x #1"
		},
		"safari": {
			"4": "a x #1",
			"5": "a x #1",
			"6": "a x #1",
			"7": "a x #1",
			"8": "a x #1",
			"9": "a x #1",
			"10": "a x #1",
			"3.1": "a x #1",
			"3.2": "a x #1",
			"5.1": "a x #1",
			"6.1": "a x #1",
			"7.1": "a x #1",
			"9.1": "a x #1",
			"TP": "a x #1"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "a x #1",
			"16": "a x #1",
			"17": "a x #1",
			"18": "a x #1",
			"19": "a x #1",
			"20": "a x #1",
			"21": "a x #1",
			"22": "a x #1",
			"23": "a x #1",
			"24": "a x #1",
			"25": "a x #1",
			"26": "a x #1",
			"27": "a x #1",
			"28": "a x #1",
			"29": "a x #1",
			"30": "a x #1",
			"31": "a x #1",
			"32": "a x #1",
			"33": "a x #1",
			"34": "a x #1",
			"35": "a x #1",
			"36": "a x #1",
			"37": "a x #1",
			"38": "a x #1",
			"39": "a x #1",
			"40": "a x #1",
			"41": "a x #1",
			"42": "a x #1",
			"43": "a x #1",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "a x #1",
			"10": "a x #1",
			"3.2": "a x #1",
			"4.0-4.1": "a x #1",
			"4.2-4.3": "a x #1",
			"5.0-5.1": "a x #1",
			"6.0-6.1": "a x #1",
			"7.0-7.1": "a x #1",
			"8.1-8.4": "a x #1",
			"9.0-9.2": "a x #1",
			"9.3": "a x #1"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "a x #1",
			"4": "a x #1",
			"53": "a x #1",
			"2.1": "a x #1",
			"2.2": "a x #1",
			"2.3": "a x #1",
			"4.1": "a x #1",
			"4.2-4.3": "a x #1",
			"4.4": "a x #1",
			"4.4.3-4.4.4": "a x #1"
		},
		"bb": {
			"7": "a x #1",
			"10": "a x #1"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "a x #1",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "a x #1"
		},
		"and_ff": {
			"49": "a x #1"
		},
		"ie_mob": {
			"10": "n",
			"11": "a #1 #2"
		},
		"and_uc": {
			"11": "a x #1"
		},
		"samsung": {
			"4": "a x #1"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "The appearance property is supported with the `none` value, but not `auto`. Webkit, Blink, and Gecko browsers also support additional vendor specific values.",
		"2": "Microsoft Edge and IE Mobile support this property with the `-webkit-` prefix, rather than `-ms-` for interop reasons."
	},
	"usage_perc_y": 0,
	"usage_perc_a": 88.66,
	"ucprefix": false,
	"parent": "",
	"keywords": "",
	"ie_id": "",
	"chrome_id": "",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-appearance.json
 ** module id = 409
 ** module chunks = 0
 **/